import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import ShopifyCreatePage from "../shopify/pages/ShopifyCreatePage.vue";
import ShopifyUpdatePage from "../shopify/pages/ShopifyUpdatePage.vue";
import ShopifyViewPage from "../shopify/pages/ShopifyViewPage.vue";

export const ShopifyRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "shopify"
) => [
  {
    name: "ShopifyViewPage",
    path: prefix,
    component: ShopifyViewPage,
    meta: { title: "Shopify List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.SHOPIFY_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "ShopifyCreatePage",
    path: `${prefix}/create`,
    component: ShopifyCreatePage,
    meta: { title: "Create New Shopify" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.SHOPIFY_CREATE
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "ShopifyUpdatePage",
    path: `${prefix}/edit/:id`,
    component: ShopifyUpdatePage,
    meta: { title: "Edit Shopify" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.SHOPIFY_UPDATE
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
